{
  "version": 1,
  "asset_id": "c0071f9b-3a2b-4c59-a338-297694e684ce",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/c0071f9b-3a2b-4c59-a338-297694e684ce/beylikduzu-hizli-elektrikci-7-24-dukkan-8.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/c0071f9b-3a2b-4c59-a338-297694e684ce/beylikduzu-hizli-elektrikci-7-24-dukkan-8.jpg",
  "original_filename": "beylikduzu-hizli-elektrikci-7-24-dukkan-8.jpg",
  "size": 460288,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:13:54Z"
}
